import { render, staticRenderFns } from "./TutorThinking.vue?vue&type=template&id=ea8edd96&scoped=true&"
import script from "./TutorThinking.vue?vue&type=script&lang=js&"
export * from "./TutorThinking.vue?vue&type=script&lang=js&"
import style0 from "./TutorThinking.vue?vue&type=style&index=0&id=ea8edd96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea8edd96",
  null
  
)

export default component.exports